module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/prasad-order/my-puja-prasad-order/my-puja-prasad-order.component.css
// module id = ./src/app/prasad-order/my-puja-prasad-order/my-puja-prasad-order.component.css
// module chunks = main